import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductPhotoModalComponent } from '../dialogs/product-photo-modal/product-photo-modal.component';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HostListener } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.sass']
})
export class StudentsComponent implements OnInit {

  screenHeight: number;
  screenWidth: number;

  mobileView: boolean;
  mobileSummaryStepper: boolean;
  mobileLandscapeImage: boolean;
  mobileSummaryItems: boolean;



  floatingButtonExtend: boolean = false;

  lets_continue = false;
  studentsListSubs: Subscription;
  students: any;
  products: any;
  all_products: any = {}
  msg: any;
  student_photo: any;
  photoURLArray: any[] = [];
  photoURLObject: any = {};
  private routeSub: Subscription;

  showPrimarySpinner: boolean = false;
  showSecondarySpinner: boolean = false;

  highlightedProducts: any = [];
  nonHighlightedProducts: any = [];


  showReservationSummary: boolean = false;

  // For product table
  // Data source is products variable
  displayedColumns: string[] = ['photo', 'description'];
  checkoutSummaryColumnsTitle: string[] = ['title'];
  checkoutSummaryColumns: string[] = ['photo-summary', 'product', 'grade', 'student', 'unit_pvp', 'quantity' /*, 'pvp'*/];
  CheckoutDataSource: any[];

  prodQtyOverview: any = {};
  selectedProducts: any[] = [];
  totalValueAmount: any = { 'amount': 0, 'currency': '€' };


  // To store different product descriptions
  productDescriptions: any = {};

  numberList: any[];

  updatingShoppingCart: any = { updating: false, itemId: '' };

  badgeNumber: any = 0;

  reservationDataForm: FormGroup;

  title: string;
  ok_txt: string;
  message: string;

  @ViewChild('stepper') stepper;
  stepperIndex: Number = 0


  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public dialog: MatDialog,
    public router: Router,
    private snackbar: MatSnackBar,
    private fb: FormBuilder

  ) {

    this.numberList = Array(10).fill(1).map((x, i) => i + 1);

    this.getScreenSize();

    this.reservationDataForm = fb.group({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      id_num: new FormControl('', Validators.required),
      tel_num: new FormControl('', Validators.required),
      accept_conditions: new FormControl(false)
    })

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;

    this.screenWidth >= 1560 ? this.mobileSummaryItems = false : this.mobileSummaryItems = true;
    this.screenWidth >= 1100 ? this.mobileView = false : this.mobileView = true;
    this.screenWidth >= 765 ? this.mobileSummaryStepper = false : this.mobileSummaryStepper = true;
    this.screenWidth >= 510 ? this.mobileLandscapeImage = false : this.mobileLandscapeImage = true;

  }

  ngOnInit(): void {

    this.showPrimarySpinner = true // Show primary spinner at beginning of loading process

    this.routeSub = this.route.params.subscribe(params => {
      if (params.relationship_id) {
        if (params.id != 'new') {
          this.studentsListSubs = this.dataService
            .getStudent({ 'relationship_id': params.relationship_id })
            .subscribe(res => {


              if (res['status'] == 'not authorized') {
                this.router.navigate(['/welcome']);
                return false;
              }
              else {
                this.showPrimarySpinner = false // Hide primary spinner once student content is loaded
                this.showSecondarySpinner = true // Show secondary spinner at beginning of loading process
                this.students = res;
                this.student_photo = [{ "imageUrl": this.students['primary_photo'] }]


                // Add photo link to array if it exists

                this.students['primary_photo'] != '' ? this.photoURLArray.push({ caption: "captions.individual_photo", url: this.students['primary_photo'] }) : console.log('dont add')
                this.students['primary_group_photo'] != '' ? this.photoURLArray.push({ caption: "captions.class_group_photo", url: this.students['primary_group_photo'] }) : console.log('dont add')
                this.students['secondary_photo'] != '' ? this.photoURLArray.push({ caption: "captions.multiple_photo", url: this.students['secondary_photo'] }) : console.log('dont add')
                this.students['secondary_group_photo'] != '' ? this.photoURLArray.push({ caption: "captions.funny_photo", url: this.students['secondary_group_photo'] }) : console.log('dont add')


                if (this.students['tpv_payment']) {

                  this.dataService.getTotalShoppingCart().subscribe(res => {

                    if (res.status == "ok") {

                      this.badgeNumber = res.total_products
                    }

                  })

                }
                let p = {}
                p['id_catalogue'] = this.students['catalogue']._flat_path[1].toString()
                p['id_relationship'] = params.relationship_id
                this.dataService.getRelatedProducts(p).subscribe(products => {
                  this.showSecondarySpinner = false // Hide secondary spinner at beginning of loading process
                  console.log(p)
                  console.log(products)

                  let all_products = products.results
                  this.products = []

                  all_products.forEach((prod: any) => {
                    if (!prod.is_gift) {
                      this.products.push(prod)
                    }

                    this.all_products[prod.id] = prod
                  })

                  this.msg = products.msg

                  // Sorts all products by priority
                  this.products.sort((a, b) => (parseInt(a.priority) > parseInt(b.priority)) ? 1 : -1);



                  // Creates an object inside a list for each product to account for selected quantities
                  all_products.forEach(element => {

                    if (!element.is_gift) {
                      element.highlighted ? this.highlightedProducts.push(element) : this.nonHighlightedProducts.push(element)
                    }

                    let description = JSON.parse(element.description)

                    this.productDescriptions[element.id] = description;
                    let type
                    if (element.individual_photo == true) {
                      type = 'primary_photo'
                    }
                    else if (element.multiple_photo == true) {
                      type = 'secondary_photo'
                    }
                    else if (element.class_group_photo == true) {
                      type = 'primary_group_photo'
                    }
                    else if (element.funny_photo == true) {
                      type = 'secondary_group_photo'
                    }
                    this.prodQtyOverview[element.id] = { 'unit': 1, 'value': element.value, 'name_es': element.name_es, 'name_en': element.name_en, 'name_cat': element.name_cat, 'type': type }

                  });

                });
              }

            },
              console.error
            );
        }

      }
    });


  }


  stepperIndexHandler(btnID: string) {

    btnID == 'next' ? this.stepperIndex = 1 : this.stepperIndex == 0 ? this.proceedToReservationCheckout() : this.stepperIndex = 0

    this.stepper.selectedIndex = this.stepperIndex;

  }



  // Changes the number selected for each product before adding it to checkout
  productQuantitySelectHandler(newQuantity: any, productId: any) {

    this.prodQtyOverview[productId].unit = newQuantity;

  }


  // Adds product to reservation checkout
  addProductToCheckout(productId: any) {

    let checkoutData = [...this.selectedProducts];

    if (!this.selectedProducts.some(({ id }) => id === productId)) {

      let product = {
        id: productId,
        unit: this.prodQtyOverview[productId].unit,
        value: this.prodQtyOverview[productId].value,
        name_en: this.prodQtyOverview[productId].name_en,
        name_es: this.prodQtyOverview[productId].name_es,
        name_cat: this.prodQtyOverview[productId].name_cat,
        type: this.prodQtyOverview[productId].type,
      }

      checkoutData.push(product)

      if (this.all_products[productId].gift_list) {
        let gifts = this.all_products[productId].gift_list.split(',')

        let selectedProdsIds = []
        this.selectedProducts.forEach(selProd => {
          selectedProdsIds.push(selProd.id)
        })

        gifts.forEach(gift => {
          if (this.prodQtyOverview[gift] != undefined && !selectedProdsIds.includes(gift)) {
            let prod = {
              id: gift,
              unit: this.prodQtyOverview[gift].unit,
              value: this.prodQtyOverview[gift].value,
              name_en: this.prodQtyOverview[gift].name_en,
              name_es: this.prodQtyOverview[gift].name_es,
              name_cat: this.prodQtyOverview[gift].name_cat,
              type: this.prodQtyOverview[gift].type,
            }

            checkoutData.push(prod)
          }
        })
      }


    } else {

      checkoutData.forEach(prod => {

        if (prod.id === productId && !this.all_products[productId].is_gift) {
          prod.unit += this.prodQtyOverview[productId].unit
        }

      })

    }


    // TODO Substitute item for real item name in popup message.
    this.translate.get('buttons.dismiss').subscribe((res: string) => {

      let dismiss = res;

      this.translate.get('alerts.item_added_res').subscribe((res: string) => {

        let msg = res;

        this.snackbar.open(msg, dismiss, { duration: 2500 })

      })

    })

    this.selectedProducts = checkoutData
    console.log(this.selectedProducts)
    this.prodQtyOverview[productId].unit = 1
    this.updateTotalValueAmount()

  }

  // Removes product form reservation checkout
  removeProductFromCheckout(productId) {

    let checkoutData = [];
    let gifts = []

    let prod = this.all_products[productId]

    if (prod.gift_list) {
      gifts = prod.gift_list.split(',')
    }

    let all_gifts = {}
    this.selectedProducts.forEach(prod => {
      let _gifts = this.all_products[prod.id].gift_list.split(',')

      if (_gifts != '') {
        _gifts.forEach(gift => {
          if (all_gifts[gift] == undefined) {
            all_gifts[gift] = 1
          }
          else {
            all_gifts[gift] += 1
          }
        })
      }
    })

    this.selectedProducts.forEach(product => {

      let anotherProductContainsGift = false

      if (product.id != productId && all_gifts[product.id] != undefined && all_gifts[product.id] > 1) {
        anotherProductContainsGift = true
      }

      if (product.id !== productId && (!gifts.includes(product.id) || anotherProductContainsGift)) {
        checkoutData.push(product)
      }

    })

    // TODO Substitute item for real item name in popup message.
    this.translate.get('buttons.dismiss').subscribe((res: string) => {

      let dismiss = res;

      this.translate.get('alerts.item_removed_res').subscribe((res: string) => {

        let msg = res;

        this.snackbar.open(msg, dismiss, { duration: 2500 })

      })

    })

    this.selectedProducts = checkoutData;
    this.updateTotalValueAmount()

  }


  addToShoppingCart(productId: any) {

    let params = {}
    params['productID'] = productId
    // params['action'] = action
    params['quantity'] = this.prodQtyOverview[productId].unit
    this.route.params.subscribe(res => {
      params['relationshipID'] = res.relationship_id
    })

    this.dataService.addRemoveToShoppingCart(params).subscribe(res => {

      this.badgeNumber = res.total_products;

      this.translate.get('buttons.dismiss').subscribe((res: string) => {

        let dismiss = res;

        this.translate.get('alerts.item_added_cart').subscribe((res: string) => {

          let msg = res;

          this.snackbar.open(msg, dismiss, { duration: 2500 })

        })

      })

    })



  }

  summaryProductQuantityHandler(newQty: any, productId: any) {

    if (newQty == 0) {

      this.removeProductFromCheckout(productId);

    } else {

      let newSelectedProducts = [...this.selectedProducts];

      newSelectedProducts.forEach(item => {

        if (item.id == productId) {

          item.unit = newQty;

        }

      })

      this.selectedProducts = newSelectedProducts;


    }

    this.updateTotalValueAmount();

  }


  // TODO Review this function's items param so it matches current format
  checkoutHandler(form: FormGroup) {
    if (!form.valid) {

      this.translate.get('buttons.dismiss').subscribe((res: string) => {

        let dismiss = res;

        this.translate.get('alerts.form_error').subscribe((res: string) => {

          let msg = res;

          this.snackbar.open(msg, dismiss, { duration: 5000, panelClass: ['error-snackbar'] })

        })

      })

      throw new Error('Invalid or missing form data')
    }

    if (form.value.accept_conditions != true) {
      this.translate.get('buttons.dismiss').subscribe((res: string) => {

        let dismiss = res;

        this.translate.get('alerts.conditions_required').subscribe((res: string) => {

          let msg = res;

          this.snackbar.open(msg, dismiss, { duration: 5000, panelClass: ['error-snackbar'] })


        })

      })
      return false;
    }


    this.translate.get('alerts.atention').subscribe(res => {
      this.title = res;
    })



    this.translate.get('buttons.ok').subscribe(res => {
      this.ok_txt = res;
    })


    this.dataService.checkReserve(this.students['id']).subscribe(res => {
      // alert(res);
      if (res == 'exists') {
        this.translate.get('alerts.more_reserves').subscribe(res => {
          this.message = res;
        })
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: this.title,
            message: this.message,
            ok_txt: this.ok_txt
          }
        }).afterClosed().subscribe(res => {

          if (res === true) {

            // this.lets_continue = true
            this.translate.get('alerts.confirm_reservation').subscribe(res => {
              this.message = res;
            })

            let dialogRef2 = this.dialog.open(ConfirmReservationDialogComponent, {
              data: {
                title: this.title,
                message: this.message + this.totalValueAmount.amount + this.totalValueAmount.currency,
                ok_txt: this.ok_txt
              }
            }).afterClosed().subscribe(res => {

              if (res === true) {

                let items = [];
                this.selectedProducts.forEach(element => {
                  items.push({ 'id': element.id, 'unit': element.unit, 'unit_value': element.value })
                });

                console.log(this.selectedProducts)


                let params = {}
                params['name'] = form.value.name
                params['surname'] = form.value.surname
                // personal_info['name'] = `${form.value.surname} ${form.value.surname}`
                params['dni'] = form.value.id_num
                params['tel_num'] = form.value.tel_num
                // personal_info['accepted_conditions'] = form.value.accept_conditions /* Must always be true, error will be thrown otherwise on line 329 */

                params['school'] = this.students['school']._flat_path[1].toString();
                params['total'] = this.totalValueAmount.amount;
                params['studentphoto_id'] = this.students['id'];
                params['items'] = JSON.stringify(items);

                this.dataService.createReserve(params).subscribe(res => {
                  this.translate.get('alerts.created_reservation').subscribe((res: string) => {
                    this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
                  })
                  this.router.navigate(['/orders']);
                })

              } else {
                // TODO Determine what happens if user cancels order here
              }

            })

          }
          else {
            // this.lets_continue = false
          }

        })
      }
      else {
        // this.lets_continue = true;
        this.translate.get('alerts.confirm_reservation').subscribe(res => {
          this.message = res;
        })

        let dialogRef2 = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: this.title,
            message: this.message + this.totalValueAmount.amount + this.totalValueAmount.currency,
            ok_txt: this.ok_txt
          }
        }).afterClosed().subscribe(res => {

          if (res === true) {

            let items = [];
            this.selectedProducts.forEach(element => {
              items.push({ 'id': element.id, 'unit': element.unit, 'unit_value': element.value })
            });



            let params = {}
            params['name'] = form.value.name
            params['surname'] = form.value.surname
            // personal_info['name'] = `${form.value.surname} ${form.value.surname}`
            params['dni'] = form.value.id_num
            params['tel_num'] = form.value.tel_num
            // personal_info['accepted_conditions'] = form.value.accept_conditions /* Must always be true, error will be thrown otherwise on line 329 */

            params['school'] = this.students['school']._flat_path[1].toString();
            params['total'] = this.totalValueAmount.amount;
            params['studentphoto_id'] = this.students['id'];
            params['items'] = JSON.stringify(items);




            this.dataService.createReserve(params).subscribe(res => {
              this.translate.get('alerts.created_reservation').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
              })
              this.router.navigate(['/orders']);
            })

          } else {
            // TODO Determine what happens if user cancels order here
          }

        })
      }


    })









  }



  openPhotoPreview(image_url: string) {

    let dialogRef = this.dialog.open(ProductPhotoModalComponent, {
      // maxWidth: '800px',
      // width: '92%',
      // maxHeight: '80%',
      backdropClass: 'photo-dialog-backdrop',
      panelClass: 'photo-dialog',
      data: image_url
    })
  }


  // Updates total value sum of all products selected.
  updateTotalValueAmount() {
    let totalAmount = 0;
    let totalItems = 0;
    this.selectedProducts.forEach(element => {
      totalAmount += (element.unit * element.value)
      totalItems += element.unit
    })
    this.totalValueAmount['amount'] = totalAmount.toFixed(2);
    this.badgeNumber = totalItems
  }


  doNotCloseMenu($event: any) {
    $event.stopPropagation();
  }




  goTo(route: string) {

    this.router.navigate([route]);

  }


  proceedToReservationCheckout() {

    this.showReservationSummary = !this.showReservationSummary;
    this.floatingButtonExtend = false

  }

  hoverOn(button: string) {

    this.floatingButtonExtend = true

  }

  hoverOff(button: string) {

    this.floatingButtonExtend = false

  }


}
